import { ImageMeta } from '@/interfaces/ticket';
import { createSlice } from '@reduxjs/toolkit';
import type { RootState } from '@/app/store';
import { MAX_NUM_IMAGES } from '@/utils/constants';

interface ImageCardsState {
  images: ImageMeta[];
  selectedImage: ImageMeta | undefined;
}

const initialState: ImageCardsState = {
  images: [],
  selectedImage: undefined,
};

export const imageCardsSlice = createSlice({
  name: 'imageCardsSlice',
  initialState,
  reducers: {
    addImageCard: (state, action) => {
      if (state.images.length < MAX_NUM_IMAGES) {
        state.images.push(action.payload);
      }
    },
    setImageCards: (state, action) => {
      state.images = action.payload;
    },
    clearImageCards: state => {
      state.images = [];
    },
    previewImage: (state, action) => {
      state.selectedImage = action.payload;
    },
  },
});

export const { addImageCard, clearImageCards, previewImage } = imageCardsSlice.actions;

export const selectImageCards = (state: RootState) => state.imageCards;

export default imageCardsSlice.reducer;
